import _ from 'lodash';

const NAME = 'task';

const DEFAULT_CURRENCY = {
  code: 'USD',
  symbol: '$',
  symbolOnLeft: true,
};

const TASK_SECTIONS = {
  ACCESS: 'access',
  ASSIGNMENTS: 'assignments',
  COMMENTS: 'comments',
  DESCRIPTION: 'description',
  ELEMENTS: 'elements',
  ISSUES: 'issues',
  NOTES: 'notes',
  PHOTOS: 'photos',
  RESERVATIONS: 'reservations',
  SUMMARY: 'summary',
  SUPPLIES: 'supplies',
};

const TASK_COST_TYPES = {
  ITEMIZED: 'itemized',
  TOTAL: 'total',
};

const TASK_CHARGED_TO_TYPES = {
  DAMAGE: 'damage',
  GUEST: 'guest',
  INTERNAL: 'internal',
  OWNER: 'owner',
  INSURANCE: 'insurance',
  REVIEW: 'review',
};

const FREQUENCY_OPTIONS = [
  {
    value: 'day',
    label: 'Daily',
  },
  {
    value: 'week',
    label: 'Weekly',
  },
  {
    value: 'bi_weekly',
    label: 'Every Other Week',
  },
  {
    value: 'month',
    label: 'Monthly',
  },
  {
    value: 'quarter',
    label: 'Quarterly',
  },
  {
    value: 'year',
    label: 'Annually',
  },
];

const FREQUENCY_OPTIONS_MAP = _.keyBy(FREQUENCY_OPTIONS, 'value');

const FREQUENCY_INTERVAL = {
  day: { frequency: 'day', interval: 1 },
  week: { frequency: 'week', interval: 1 },
  bi_weekly: { frequency: 'week', interval: 2 },
  month: { frequency: 'month', interval: 1 },
  quarter: { frequency: 'month', interval: 3 },
  year: { frequency: 'year', interval: 1 },
};

const REQUESTER_TYPES = [
  'owner',
  'guest',
  'guest_survey',
  'inspector',
  'housekeeper',
  'maintenance_tech',
  'property_services',
  'property_manager',
  'dispatcher',
];

const TOOLTIPS = {
  issue:
    'Setting this task as an issue will notify Admins and Supervisors on your team of the issue.',
  service_request:
    'Breezeway messaging now allows you to send SMS task status updates to a guest, or owner.',
};

export default {
  DEFAULT_CURRENCY,
  NAME,
  TASK_CHARGED_TO_TYPES,
  TASK_COST_TYPES,
  TASK_SECTIONS,
  FREQUENCY_OPTIONS,
  FREQUENCY_OPTIONS_MAP,
  FREQUENCY_INTERVAL,
  REQUESTER_TYPES,
  TOOLTIPS,
};
